var portfolioPositionsPerformance = {
	caption: "Performance di posizioni di portafoglio ",
	label: {
		name: "Nome",
		isin: "ISIN",
		performance: "Perf.",
		performanceRelative: "Perf. %",
		performanceBar: "Perf. % di max"
	},
	noPositions: "Nessun risultato trovato"
};
var it = {
	portfolioPositionsPerformance: portfolioPositionsPerformance
};

export { it as default, portfolioPositionsPerformance };
